<style scoped>
</style>

<template>
  <div>
    <Card shadow>
      <Button type="primary" icon="md-add" @click="addIOSMbCertForm.modal = true " >描述文件</Button>
      <Button type="primary" icon="md-add" @click="addIOSPushCertForm.modal = true " style="margin-left:10px;" >推送证书文件</Button>
      <Table
        border
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
      >
        <template slot-scope="{row}" slot="fileType">
          {{row.fileType == 1?'推送证书':'描述文件'}}
        </template>
        <template slot-scope="{row}" slot="expiredate">
            <div v-html="dealExpireDate(row.expiredate)" ></div>
        </template>
        <template slot-scope="{row}" slot="opt">
          <Button  size="small" @click.stop="setEnable(row, true)" v-if="row.status == 0">启用</Button>
          <Button
            size="small"
            @click.stop="setEnable(row, false)"
            v-else-if="row.status == 1"
            type="error"
          >禁用</Button>
          <Button 
            style="margin-left:10px;"  
            size="small" 
            @click.stop="downCert(row)" 
            type="warning"
        >下载</Button>
          <Button
            style="margin-left:10px;"
            size="small"
            @click.stop="showUpdateCert(row)"
            type="primary"
          >更新</Button>
          <Button
            style="margin-left:10px;"
            size="small"
            @click.stop="del(row)"
            type="error"
          >删除</Button>
        </template>
      </Table>
    </Card>

    <!-- p12 推送证书文件表单会话 BEGIN -->
    <Modal 
      v-model="addIOSPushCertForm.modal"
      @on-visible-change="onModalPushVisibleChange" 
      :title="addIOSPushCertForm.isUpdate ? '更新推送证书' : '推送证书' "
    >
        <Alert type="warning">注意：包名、过期时间，需要手动输入！</Alert>
        <div style="height:75px;">
            <Upload
                ref="uploadPushCer"
                :format="['p12']"
                :action="filePushUpload.uploadurl"
                :data="filePushUpload.fileUploadParams"
                :headers="filePushUpload.headers"
                :show-upload-list="true"
                :on-success="onPushCerFileUploadSuccess"
                :on-error="onCertUploadError"
                :on-format-error="onPushCertFileFormatUploadError"
              >
                <Button icon="ios-cloud-upload-outline">选择推送证书</Button>
            </Upload>
            <span
            style="color:green;margin-left:10px;line-height:32px"
            v-if="filePushUpload.hasPushCerUpload"
            >已上传</span>
        </div>

        <div style="height:75px;">
            <div style="line-height:33px;">包名（项目名称，尽量保持唯一）</div>
            <Input placeholder="描述文件名称" v-model="addIOSPushCertForm.model.bundleIdName" ></Input>
        </div>

        <div style="height:75px;">
            <div style="line-height:33px;">过期时间</div>
            <DatePicker @on-change="onPushCertDateChange"  v-model="pushCerDatePickerValue"  type="date" placeholder="选择日期" style="width: 200px"></DatePicker>
        </div>

        <div slot="footer">
          <Button type="text" size="large" @click="addPushUpdateCancel">取消</Button>
          <Button v-if="!addIOSPushCertForm.isUpdate"  type="primary" size="large" @click="addUpdatePushSubmit">确定</Button>
          <Button v-if="addIOSPushCertForm.isUpdate"  type="warning" size="large" @click="goUpdatePushSubmit">更新</Button>
        </div>

    </Modal>
    <!-- p12 推送证书文件表单会话 END -->


    <Modal 
       v-model="addIOSMbCertForm.modal" 
      @on-visible-change="onModalVisibleChange" 
      :title="addIOSMbCertForm.isUpdate ? '更新描述文件' : '描述文件' " >
        <div style="height:75px;">
            <Upload
                ref="uploadMbCer"
                :format="['mobileprovision']"
                :action="fileUpload.uploadurl"
                :data="fileUpload.fileUploadParams"
                :headers="fileUpload.headers"
                :show-upload-list="true"
                :on-success="onMBCerFileUploadSuccess"
                :on-error="onCertUploadError"
                :on-format-error="onCertFileFormatUploadError"
              >
                <Button icon="ios-cloud-upload-outline">选择证书</Button>
            </Upload>
            <span
            style="color:green;margin-left:10px;line-height:32px"
            v-if="fileUpload.hasPushCerUpload"
            >已上传</span>
        </div>
        <div style="height:75px;">
            <div style="line-height:33px;">包名</div>
            <Input placeholder="描述文件包名" v-model="addIOSMbCertForm.model.bundleIdName" readonly></Input>
        </div>
        <div style="height:75px;">
            <div style="line-height:33px;">过期时间</div>
            <Input placeholder="过期时间" v-model="addIOSMbCertForm.model.expiredateDisplayname" readonly></Input>
        </div>
        <div slot="footer">
          <Button type="text" size="large" @click="addUpdateCancel">取消</Button>
          <Button v-if="!addIOSMbCertForm.isUpdate"  type="primary" size="large" @click="addUpdateSubmit">确定</Button>
          <Button v-if="addIOSMbCertForm.isUpdate"  type="warning" size="large" @click="goUpdateSubmit">更新</Button>
        </div>
    </Modal>

  </div>
</template>
<script>
export default {
  data() {
    return {
      pushCerDatePickerValue:"",
      tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "index",
            width: 60,
            align: "center",
          },
          {
            title: "Bundle包名",
            key: "bundleIdName",
          },
          {
            title: "类型",
            key: "fileType",
            slot: "fileType",
          },
          {
            title: "过期时间",
            key: "expiredate",
            slot: "expiredate",
          },
          {
            title: "操作",
            slot: "opt",
          },
        ],
      },
      addIOSMbCertForm:{
        modal:false,
        isUpdate:false,
        model:{}
      },
      addIOSPushCertForm:{
        modal:false,
        isUpdate:false,
        model:{}
      },
      fileUpload: {
        hasUpload: false,
        hasPushCerUpload: false,
        fileUploadParams: {
          clientguid: this.$route.params.projectguid,
          userguid: localStorage.userguid
        },
        headers: {
          Authorization: localStorage.token
        },
        uploadurl: this.$axios.defaults.baseURL + "/base/iosmpbcert/analysembpcert",
      },
      filePushUpload: {
        hasUpload: false,
        hasPushCerUpload: false,
        fileUploadParams: {
          clientguid: this.$route.params.projectguid,
          userguid: localStorage.userguid
        },
        headers: {
          Authorization: localStorage.token
        },
        uploadurl: this.$axios.defaults.baseURL + "/base/iosmpbcert/uploadPushCert",
      }
    };
  },
  methods: {
    addUpdatePushSubmit(){
      let _this = this;
        _this.tdata.loading = true;
        this.$http.post({
            method: "base/iosmpbcert/addCert",
            params: {
              ...this.addIOSPushCertForm.model,
              addType:1,
            },
            success: function (data) {
                _this.tdata.loading = false;
                _this.getCertList();
                _this.addPushUpdateCancel();
            },
            failure(code, msg) {
                _this.tdata.loading = false;
                _this.addIOSPushCertForm.modal = false;
                _this.getCertList();
                _this.$Message.warning({
                        title: "提示",
                        content: msg,
                });
            },
        });
    },
    addPushUpdateCancel(){
      this.addIOSPushCertForm.modal = false;
      this.addIOSPushCertForm.model = {};
    },
    onPushCertDateChange(date = ""){
      if (date.length <= 0) {
          // this.addIOSPushCertForm.model.expiredate = "";
      } else {
          this.addIOSPushCertForm.model.expiredate = new Date(date+" 00:00:00").getTime();
      }
    },
    goUpdatePushSubmit(){
      let _this = this;
        _this.tdata.loading = true;
        this.$http.post({
            method: "base/iosmpbcert/updateCert",
            params: this.addIOSPushCertForm.model,
            success: function (data) {
                _this.tdata.loading = false;
                _this.getCertList();
                _this.addPushUpdateCancel();
            },
            failure(code, msg) {
                _this.tdata.loading = false;
                _this.$Message.warning({
                        title: "提示",
                        content: msg,
                });
            },
        });
    },
    goUpdateSubmit(){
      let _this = this;
        _this.tdata.loading = true;
        this.$http.post({
            method: "base/iosmpbcert/updateCert",
            params: this.addIOSMbCertForm.model,
            success: function (data) {
                _this.tdata.loading = false;
                _this.getCertList();
                _this.addUpdateCancel();
            },
            failure(code, msg) {
                _this.tdata.loading = false;
                _this.$Message.warning({
                        title: "提示",
                        content: msg,
                });
            },
        });
    },
    showUpdateCert(row){
      let expire = new Date(row.expiredate);
      if (row.fileType == 1) {
        this.addIOSPushCertForm.isUpdate = true;
        this.addIOSPushCertForm.model = {
          bundleIdName:row.bundleIdName,
          filetag:row.filetag,
          id:row.id,
          expiredate:expire.getTime(),
        };
        this.pushCerDatePickerValue = expire;
        this.addIOSPushCertForm.modal = true;
      } else {
        this.addIOSMbCertForm.isUpdate = true;
        this.addIOSMbCertForm.model = {
          bundleIdName:row.bundleIdName,
          filetag:row.filetag,
          id:row.id,
          expiredate:expire.getTime(),
          expiredateDisplayname:expire.getFullYear() + "年"+(parseInt( expire.getMonth())+1) + "月" +  expire.getDate() + "日"
        };
        this.addIOSMbCertForm.modal = true;
      }
    },
    del(row){
        if (window.confirm("是否确认删除该条记录")) {
          let _this = this;
        _this.tdata.loading = true;
          this.$http.post({
            method: "base/iosmpbcert/delCert",
            params: {
              id:row.id
            },
            success: function (data) {
                _this.tdata.loading = false;
                _this.getCertList();
            },
            failure(code, msg) {
                _this.addIOSMbCertForm.modal = false;
                _this.tdata.loading = false;
                _this.$Message.warning({
                        title: "提示",
                        content: msg,
                });
            },
          })
        } 
    },
    downCert(row){
      let downurl = this.$axios.defaults.baseURL + "/base/iosmpbcert/downcert?id="+row.id;
      window.open(downurl);
    },
    onModalVisibleChange(visible){
      this.$refs["uploadMbCer"].clearFiles();
        if (!visible) {
            this.addIOSMbCertForm.isUpdate = false;
            this.addIOSMbCertForm.model = {};
        }
    },
    onModalPushVisibleChange(visible){
      this.$refs["uploadPushCer"].clearFiles();
      
        if (!visible) {
            this.addIOSPushCertForm.isUpdate = false;
            this.addIOSPushCertForm.model = {};
            this.pushCerDatePickerValue = "";
        }
    },
    addUpdateSubmit(){
        let _this = this;
        _this.tdata.loading = true;
        this.$http.post({
            method: "base/iosmpbcert/addCert",
            params: this.addIOSMbCertForm.model,
            success: function (data) {
                _this.tdata.loading = false;
                _this.getCertList();
                _this.addUpdateCancel();
            },
            failure(code, msg) {
                _this.tdata.loading = false;
                _this.addIOSMbCertForm.modal = false;
                _this.getCertList();
                _this.$Message.warning({
                        title: "提示",
                        content: msg,
                });
            },
        });
    },
    addUpdateCancel(){
        this.addIOSMbCertForm.modal = false;
        this.addIOSMbCertForm.model = {};
    },
    getCertList(){
        let _this = this;
        this.$http.get({
            method: "base/iosmpbcert/getCertList",
            params: {},
            success: function (data) {
                _this.tdata.current_data = data;
            },
            failure(code, msg) {
                _this.$Message.warning({
                        title: "提示",
                        content: msg,
                });
            },
        });
    },
    dealExpireDate(expiredate){
        let leavetimestamp = new Date(`${expiredate} 08:00:00`).getTime() - new Date().getTime()
        let leavedays = Math.floor(leavetimestamp/(1000*24*3600));
        if ((leavedays <= 60) && (leavedays > 30)) {
          return  `剩余<span style='color:#fc911d;font-size:12px;' >${leavedays}</span>天`;
        } else if ((leavedays <= 30) && (leavedays > 0)) {
          return  `剩余<span style='color:#e8361b;font-size:12px;' >${leavedays}</span>天`;
        } else if (leavedays <= 0) {
          return  `<span style='color:#e8361b;font-size:12px;' >已过期${leavedays}天</span>`;
        } else {
          return `剩余<span style='color:#347aca;font-size:12px;' >${leavedays}</span>天`;
        }
    },
    onMBCerFileUploadSuccess(resp){
        let expire = new Date(resp.data.expiredate);
        let isUpdate = this.addIOSMbCertForm.isUpdate;
        let id = this.addIOSMbCertForm.model.id;
        this.addIOSMbCertForm.model = {
            expiredateDisplayname:expire.getFullYear() + "年"+(parseInt( expire.getMonth())+1) + "月" +  expire.getDate() + "日",
            expiredate:expire.getTime(),
            bundleIdName:resp.data.bundleid,
            filetag:resp.data.filetag,
            id:id
        };
    },
    onPushCerFileUploadSuccess(resp){
      this.addIOSPushCertForm.model.filetag = resp.data.filetag;
    },
    onCertUploadError(error){
        this.$Message.warning({
                title: "提示",
                content: error,
        });
    },
    onCertFileFormatUploadError(){
        this.$Message.warning({
                title: "提示",
                content: "请上传 mobileprovision 文件",
        });
    },
    onPushCertFileFormatUploadError(){
        this.$Message.warning({
                title: "提示",
                content: "请上传 p12 文件",
        });
    },
    setEnable(row, enable){
        let _this = this;
        _this.tdata.loading = true;
        this.$http.post({
            method: "base/iosmpbcert/setEnable",
            params: {
                id:row.id,
                enable:enable
            },
            success: function (data) {
                let updateIndex = -1;
                for (let i = 0; i<_this.tdata.current_data.length; i++) {
                    if (_this.tdata.current_data[i].id == row.id) {
                        updateIndex = i;
                        break;
                    }
                }
                if (updateIndex > -1) {
                    let list = _this.tdata.current_data;
                    list[updateIndex].status = enable?1:0;
                    _this.tdata.current_data = list;
                    _this.tdata.loading = false;
                }
            },
            failure(code, msg) {
                _this.tdata.loading = false;
                _this.$Message.warning({
                    title: "提示",
                    content: msg,
                });
            },
        });
    }
  },
  mounted() {
    this.getCertList();
  },
};
</script>